var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navSection"},[_c('div',{staticClass:"title-bar",style:('background-color: ' + _vm.item.bgColor.color[0].item + ';')},[_c('span',{style:('color:' + _vm.item.titleColor.color[0].item)},[_vm._v(_vm._s(_vm.item.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }